export class Agreement {
	agreementId: number;
	agreementDate: Date;
	name: string;
	number: string;
	contragentId: number;
	stateId: number;
	stateName: string;
	executorId: number;
	parentAgreementId: number;
	integraCode: string;
	agreementTypeId: number;
	endDate: Date;
	possibleProlongation: boolean;
	description: string;
	agreementServiceTypeId: number;
	customerObjectId: number;
	discount: number;
	duration: number;
	serviceInterval: number;
	serviceCenterId: number;
	customerObjectDeviceIds: number[] = [];
	servicesFullCost: number;
	devicesFullCost: number;
	notRequireDevices: boolean;
	plannedServicesCount: number;
	plannedDevicesCount: number;
	isFinalCommit: boolean;

	hasConflictDevices: boolean;
}
